import { ChatAssistant } from '@/models/assistant-types';
import { Conversation } from '@/models/conversation';
import httpService from './HttpService';

class ChatHistoryService {
  async getUserConversations(
    assistant: ChatAssistant
  ): Promise<Record<string, Conversation>> {
    const endpoint = `/chat-histories?assistant=${encodeURIComponent(assistant)}`;
    const response =
      await httpService.get<Record<string, Conversation>>(endpoint);
    return response;
  }

  async getConversationHistory(
    conversationId: string
  ): Promise<Conversation | null> {
    if (!conversationId) return null;

    const endpoint = `/chat-histories/${encodeURIComponent(conversationId)}`;

    return await httpService.get<Conversation>(endpoint);
  }

  async deleteConversation(conversationId: string): Promise<void> {
    const endpoint = `/chat-histories/${encodeURIComponent(conversationId)}`;
    await httpService.delete(endpoint);
  }
}

export default new ChatHistoryService();
